export default __webpack_public_path__ + "static/media/pgsql.ab857a72.svg";